import React from 'react';
// import {useState} from 'react';
import * as Panel2 from './panel';
// import {Button, Modal} from 'semantic-ui-react';
// import {Spec as PanelRunsLinePlotSpec} from '../PanelRunsLinePlot';
// import * as OldQueryTS from '../../util/queryts';
// import * as Filter from '../../util/filters';
// import {useHistoryKeysQuery} from '../../state/graphql/historyKeysQuery';
// import {RunQueryContext} from '../../state/runs/context';
// import {RunHistoryKeyInfo} from '../../types/run';

const inputType = {
  type: 'query' as const,
  resultType: {
    type: 'array' as const,
    objectType: 'run' as const,
  },
};

type PanelRunsPanel1Props = Panel2.PanelProps<typeof inputType>;

const PanelRunsPanel1: React.FC<PanelRunsPanel1Props> = props => {
  // TODO
  return <div>NOT YET IMPLEMENTED</div>;
  // // TODO: improve type function so we don't have to cast
  // const [editMode, setEditMode] = useState(false);
  // let entityName: string;
  // let projectName: string;
  // let filters: Filter.Filter = Filter.TRUE_FILTER;
  // // TODO: super hacked up. Components aren't allowed to this kind of type
  // // switching.
  // if (Query.queryRootIsRuns(props.input.value.root)) {
  //   const runIds = props.input.value.root as QueryRuns.RunId[];
  //   entityName = runIds[0].entityName;
  //   projectName = runIds[0].projectName;
  //   filters = {
  //     op: 'OR' as const,
  //     filters: runIds.map(rid => ({
  //       key: {section: 'run' as const, name: 'name'},
  //       op: '=' as const,
  //       value: rid.runName,
  //     })),
  //   };
  // } else if (Query.queryRootIsProject(props.input.value.root)) {
  //   entityName = props.input.value.root.entityName;
  //   projectName = props.input.value.root.projectName;
  // } else {
  //   throw new Error('invalid');
  // }
  // const baseQuery = {
  //   entityName,
  //   projectName,
  //   grouping: [],
  //   filters: Filter.TRUE_FILTER,
  //   sort: OldQueryTS.CREATED_AT_DESC,
  // };
  // // TODO: watch out, assuming at least 1!
  // const hkq = useHistoryKeysQuery(baseQuery);
  // const pageQuery: OldQueryTS.Query = {
  //   ...baseQuery,
  //   id: 'top-level-query',
  //   runSets: [
  //     {
  //       ...baseQuery,
  //       filters,
  //       selections: Filter.TRUE_FILTER,
  //       id: 'rs-0',
  //       enabled: true,
  //     },
  //   ],
  // };
  // if (hkq.loading) {
  //   return <div>loading</div>;
  // }
  // if (hkq.error) {
  //   return <div>error</div>;
  // }
  // const panelConfig = {
  //   ...(props.config as any),
  //   xAxis: (props.config as any)?.xAxis ?? '_runtime',
  // };
  // return (
  //   <RunQueryContext.Provider
  //     value={{
  //       entityName,
  //       projectName,
  //       // mergeFilters: props.mergeFilters,
  //       runSetName: 'rq-context',
  //     }}>
  //     <Modal open={editMode} onClose={() => setEditMode(false)}>
  //       <Modal.Content>
  //         <PanelRunsPanel1Inner
  //           configMode={true}
  //           config={panelConfig}
  //           historyKeyInfo={hkq.historyKeyInfo}
  //           pageQuery={pageQuery}
  //           updateConfig={props.updateConfig}
  //         />
  //       </Modal.Content>
  //     </Modal>
  //     <div
  //       style={{
  //         width: 400,
  //         height: 250,
  //         display: 'flex',
  //         flexDirection: 'column',
  //       }}>
  //       <div style={{display: 'flex', justifyContent: 'flex-end'}}>
  //         <Button onClick={() => setEditMode(true)}>Edit</Button>
  //       </div>
  //       <PanelRunsPanel1Inner
  //         configMode={false}
  //         config={panelConfig}
  //         historyKeyInfo={hkq.historyKeyInfo}
  //         pageQuery={pageQuery}
  //         updateConfig={props.updateConfig}
  //       />
  //     </div>
  //   </RunQueryContext.Provider>
  // );
  // return <div>{JSON.stringify(pageQuery)}</div>;
};

// const PanelRunsPanel1Inner: React.FC<{
//   configMode: boolean;
//   config: any;
//   historyKeyInfo: RunHistoryKeyInfo;
//   pageQuery: OldQueryTS.Query;
//   updateConfig(newConfig: any): void;
// }> = props => {
//   const {configMode, config, pageQuery, historyKeyInfo, updateConfig} = props;
//   return (
//     <PanelRunsLinePlotSpec.Component
//       configMode={configMode}
//       pageQuery={pageQuery}
//       currentHeight={300}
//       dimensions={{w: 300, h: 300}}
//       runSetRefs={[]}
//       loading={false}
//       data={null as any}
//       query={null as any}
//       runsDataQuery={null as any}
//       // TODO: can type this
//       config={config}
//       updateConfig={newConfig =>
//         updateConfig({...(props.config as any), ...newConfig})
//       }
//       keyInfo={historyKeyInfo}
//     />
//   );
// };

export const Spec: Panel2.PanelSpec = {
  id: 'runs-panel',
  // ConfigComponent: PanelRunsPanel1Config,
  Component: PanelRunsPanel1,
  inputType,
};
